import { DefaultEffects, IButtonStyles, IImageStyleProps, IImageStyles, IStyleFunctionOrObject, ITextFieldStyleProps, ITextFieldStyles, mergeStyles } from "@fluentui/react";


export const loginBoxPageContainer = mergeStyles([{
    width: '100dvw',
    minWidth: '100dvw',
    minHeight: '100dvh',
    backgroundColor: '#FFFFFF',
    fontFamily: 'Nunito'
}]);

export const loginBoxContainer = mergeStyles([{
    width: '41dvw',
    minWidth: '41dvw',
    fontFamily: 'Nunito',
    boxShadow: DefaultEffects.elevation16,
    border: '0 solid rgba(0,0,0,.125)',
    borderTop: '5px solid #2A7DE1',
    borderRadius: 8
}]);

export const xxlLoginBoxContainer = mergeStyles([{
    width: '40dvw',
    minWidth: '40dvw',
    fontFamily: 'Nunito',
    boxShadow: DefaultEffects.elevation16,
    border: '0 solid rgba(0,0,0,.125)',
    borderTop: '5px solid #2A7DE1',
    borderRadius: 8
}]);

export const xlLoginBoxContainer = mergeStyles([{
    width: '70dvw',
    minWidth: '70dvw',
    fontFamily: 'Nunito',
    boxShadow: DefaultEffects.elevation16,
    border: '0 solid rgba(0,0,0,.125)',
    borderTop: '5px solid #2A7DE1',
    borderRadius: 8
}]);

export const lgLoginBoxContainer = mergeStyles([{
    width: '65dvw',
    minWidth: '65dvw',
    fontFamily: 'Nunito',
    boxShadow: DefaultEffects.elevation16,
    border: '0 solid rgba(0,0,0,.125)',
    borderTop: '5px solid #2A7DE1',
    borderRadius: 8
}]);

export const mdLoginBoxContainer = mergeStyles([{
    width: '98dvw',
    minWidth: '98dvw',
    fontFamily: 'Nunito',
    borderTop: '5px solid #2A7DE1',
    borderRadius: 8
}]);

export const smLoginBoxContainer = mergeStyles([{
    width: '98dvw',
    minWidth: '98dvw',
    fontFamily: 'Nunito',
    borderTop: '5px solid #2A7DE1',
    borderRadius: 8
}]);

export const loginLogoContainer = mergeStyles([{
    width: '100%',
    borderBottom: '1px solid rgba(0,0,0,.125)'
}]);

export const logoStyles: IStyleFunctionOrObject<IImageStyleProps, IImageStyles> = {
    image: {
        width: '15dvw',
        height: 'auto'
    }
};

export const registerLinkStyles = mergeStyles([{
    width: '100%',
    padding: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderTop: '1px solid #d4d4d4'
}]);

export const welcomeContainerStyles = mergeStyles([{
    paddingTop: '2dvh',
    paddingBottom: '2dvh',
    paddingLeft: '1dvw',
    paddingRight: '1dvw',
}]);

export const smallWelcomeContainerStyles = mergeStyles([{
    paddingTop: '4dvh',
    paddingBottom: '4dvh',
}]);

//#region FORM

export const privateFormContainer = mergeStyles([{
    padding: '1dvh'
}]);

export const titleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: '1.5rem',
    fontWeight: 700,
}]);

export const xxlTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: '1.3rem',
    fontWeight: 700,
}]);

export const xlTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: '1.1rem',
    fontWeight: 700,
}]);

export const lgTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: '1rem',
    fontWeight: 700,
}]);

export const mdTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: '1.4rem',
    fontWeight: 700,
}]);

export const smTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: '1.3rem',
    fontWeight: 700,
}]);

export const subTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: '1.1rem',
    textAlign: 'center',
    fontWeight: 400,
}]);

export const xxlSubTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: '0.900rem',
    textAlign: 'center',
    fontWeight: 400,
}]);

export const xlSubTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: '0.900rem',
    textAlign: 'center',
    fontWeight: 400,
}]);

export const lgSubTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: '0.875rem',
    textAlign: 'center',
    fontWeight: 400,
}]);

export const mdSubTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: '0.900rem',
    textAlign: 'center',
    fontWeight: 400,
}]);

export const smSubTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: '0.950rem',
    textAlign: 'center',
    fontWeight: 400,
}]);

export const loginBoxTextFieldStyles: IStyleFunctionOrObject<ITextFieldStyleProps, ITextFieldStyles>  = {
    root: {
        fontFamily: 'Nunito',
        fontSize: '1.2rem'
    },
    subComponentStyles: {
        label: {
            root: {
                fontFamily: 'Nunito',
                fontSize: '1.2rem',
            }
        }
    },
    fieldGroup: {
        height: '2.5rem',
        fontFamily: 'Nunito',
        fontSize: '1.2rem',
        boxShadow: DefaultEffects.elevation8,
    },
    field: {
        fontFamily: 'Nunito',
        fontSize: '1.2rem',
    },
    errorMessage: {
        fontFamily: 'Nunito',
        fontSize: '1rem',
    }
}

export const xxlLoginBoxTextFieldStyles: IStyleFunctionOrObject<ITextFieldStyleProps, ITextFieldStyles>  = {
    root: {
        fontFamily: 'Nunito',
        fontSize: '1.2rem',
    },
    subComponentStyles: {
        label: {
            root: {
                fontFamily: 'Nunito',
                fontSize: '1.2rem',
            }
        }
    },
    fieldGroup: {
        height: '2.4rem',
        fontFamily: 'Nunito',
        fontSize: '1.2rem',
        boxShadow: DefaultEffects.elevation8,
    },
    field: {
        fontFamily: 'Nunito',
        fontSize: '1.2rem',
    },
    errorMessage: {
        fontFamily: 'Nunito',
        fontSize: '1.2rem',
    }
}

export const xlLoginBoxTextFieldStyles: IStyleFunctionOrObject<ITextFieldStyleProps, ITextFieldStyles>  = {
    root: {
        fontFamily: 'Nunito',
        fontSize: '1rem',
    },
    subComponentStyles: {
        label: {
            root: {
                fontFamily: 'Nunito',
                fontSize: '1rem',
            }
        }
    },
    fieldGroup: {
        height: '2.4rem',
        fontFamily: 'Nunito',
        fontSize: '1rem',
        boxShadow: DefaultEffects.elevation8,
    },
    field: {
        fontFamily: 'Nunito',
        fontSize: '1rem',
    },
    errorMessage: {
        fontFamily: 'Nunito',
        fontSize: '1rem',
    }
}

export const lgLoginBoxTextFieldStyles: IStyleFunctionOrObject<ITextFieldStyleProps, ITextFieldStyles>  = {
    root: {
        fontFamily: 'Nunito',
        fontSize: '1.2rem',
    },
    subComponentStyles: {
        label: {
            root: {
                fontFamily: 'Nunito',
                fontSize: '1.2rem',
            }
        }
    },
    fieldGroup: {
        height: '2.2rem',
        fontFamily: 'Nunito',
        fontSize: '1.2rem',
        boxShadow: DefaultEffects.elevation8,
    },
    field: {
        fontFamily: 'Nunito',
        fontSize: '1.2rem',
    },
    errorMessage: {
        fontFamily: 'Nunito',
        fontSize: '1.2rem',
    }
}

export const mdLoginBoxTextFieldStyles: IStyleFunctionOrObject<ITextFieldStyleProps, ITextFieldStyles>  = {
    root: {
        fontFamily: 'Nunito',
        fontSize: '1.2rem',
    },
    subComponentStyles: {
        label: {
            root: {
                fontFamily: 'Nunito',
                fontSize: '1.2rem',
            }
        }
    },
    fieldGroup: {
        height: '2.5rem',
        fontFamily: 'Nunito',
        fontSize: '1.2rem',
        boxShadow: DefaultEffects.elevation8,
    },
    field: {
        fontFamily: 'Nunito',
        fontSize: '1.2rem',
    },
    errorMessage: {
        fontFamily: 'Nunito',
        fontSize: '1rem',
    }
}

export const smLoginBoxTextFieldStyles: IStyleFunctionOrObject<ITextFieldStyleProps, ITextFieldStyles>  = {
    root: {
        fontFamily: 'Nunito',
        fontSize: '1.2rem',
    },
    subComponentStyles: {
        label: {
            root: {
                fontFamily: 'Nunito',
                fontSize: '1.2rem',
            }
        }
    },
    fieldGroup: {
        height: '2.5rem',
        fontFamily: 'Nunito',
        fontSize: '1.2rem',
        boxShadow: DefaultEffects.elevation8,
    },
    field: {
        fontFamily: 'Nunito',
        fontSize: '1.2rem'
    },
    errorMessage: {
        fontFamily: 'Nunito',
        fontSize: '1rem',
    }
}

export const loginButtonStyles: IButtonStyles = {
    root: {
        backgroundColor: '#2A7DE1',
        height: '2.5rem',
        fontFamily: 'Nunito',
        fontSize: '1.2rem',
        marginTop: '2dvh',
        borderRadius: 20,
        boxShadow: DefaultEffects.elevation8,
    },
    rootHovered: {
        backgroundColor: '#0078d4'
    }
}

export const xxlLoginButtonStyles: IButtonStyles = {
    root: {
        backgroundColor: '#2A7DE1',
        height: '2rem',
        fontFamily: 'Nunito',
        fontSize: '1rem',
        marginTop: '2dvh',
        borderRadius: 20,
        boxShadow: DefaultEffects.elevation8,
    },
    rootHovered: {
        backgroundColor: '#0078d4'
    }
}

export const xlLoginButtonStyles: IButtonStyles = {
    root: {
        backgroundColor: '#2A7DE1',
        height: '2.4rem',
        fontFamily: 'Nunito',
        fontSize: '1rem',
        marginTop: '2dvh',
        borderRadius: 20,
        boxShadow: DefaultEffects.elevation8,
    },
    rootHovered: {
        backgroundColor: '#0078d4'
    }
}

export const lgLoginButtonStyles: IButtonStyles = {
    root: {
        backgroundColor: '#2A7DE1',
        height: '2.2rem',
        fontFamily: 'Nunito',
        fontSize: '1.2rem',
        marginTop: '2dvh',
        borderRadius: 20,
        boxShadow: DefaultEffects.elevation8,
    },
    rootHovered: {
        backgroundColor: '#0078d4'
    }
}

export const mdLoginButtonStyles: IButtonStyles = {
    root: {
        backgroundColor: '#2A7DE1',
        height: '2.5rem',
        fontFamily: 'Nunito',
        fontSize: '1.2rem',
        marginTop: '2dvh',
        borderRadius: 20,
        boxShadow: DefaultEffects.elevation8,
    },
    rootHovered: {
        backgroundColor: '#0078d4'
    }
}

export const smLoginButtonStyles: IButtonStyles = {
    root: {
        backgroundColor: '#2A7DE1',
        height: '2.5rem',
        fontFamily: 'Nunito',
        fontSize: '1.2rem',
        marginTop: '2dvh',
        borderRadius: 20,
        boxShadow: DefaultEffects.elevation8,
    },
    rootHovered: {
        backgroundColor: '#0078d4'
    }
}

export const wrongPasswordContainerStyles = mergeStyles([{
    paddingTop: '1dvh',
}]);


//#endregion